module.exports = __webpack_public_path__ + "img/plus_default.37af12c5.svg";